import { lazy } from 'react';

const ServiciosPintura = lazy(() =>
  import('components/Importadora/Servicios-Pintura/ServiciosPintura').then(module => ({
    default: module.ServiciosPintura,
  }))
);

const CostosVehiculos = lazy(() =>
  import('components/Importadora/Costos-Vehiculos/CostosVehiculos').then(module => ({
    default: module.CostosVehiculos,
  }))
);

const VehicleCatalog = lazy(() =>
  import('components/Importadora/VehicleCatalog/VehicleCatalog').then(module => ({
    default: module.VehicleCatalog,
  }))
);

const routesImportadora = [
  {
    path: "/vehiculos-catalogo",
    name: "Catalogo de Vehiculos",
    icon: "nc-icon nc-delivery-fast",
    component: <VehicleCatalog />,
    permissions: ['145_MODULO_IMPORTADORA', '49_ADMIN'],
    layout: "/app",
    visibility: true,
    subRoutes: [],
  },
  {
    path: "/servicios-pintura",
    name: "Servicios Pintura",
    icon: "nc-icon nc-palette",
    component: <ServiciosPintura />,
    permissions: ['IMPORTADORA', 'ADMIN'],
    layout: "/app",
    visibility: true,
    subRoutes: [],
  },
  {
    path: "/costos-vehiculos",
    name: "Costos Vehiculos",
    icon: "nc-icon nc-bank",
    component: <CostosVehiculos />,
    permissions: ['IMPORTADORA', 'ADMIN'],
    layout: "/app",
    visibility: true,
    subRoutes: [],
  },
]

export {
  routesImportadora
}